import React from 'react'

const Campaign = () => {
  return (
    <div>Campaign</div>
  )
}

export default Campaign